import { Typography } from '@material-ui/core';

const EmptyState = ({ message }) => {
  return (
    <div className="text-center py-12">
      <Typography variant="body1" component="p" className="text-stone-500">
        {message}
      </Typography>
    </div>
  );
};

export default EmptyState;
